import { useNavigate } from 'react-router-dom';

const featureCards = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Spreadsheet 101',
    desc: 'Learn spreadsheet basics',
    link: '/article/cssbuy-spreadsheet-guide',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'How to QC',
    desc: 'Master quality checking',
    link: '/article/how-to-qc',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Hacks',
    desc: 'Save on every parcel',
    link: '/article/shopping-guide',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Avoid Scams',
    desc: 'Stay safe shopping',
    link: '/article/shopping-guide',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Brand Index',
    desc: 'Every brand, one place',
    link: '/article/cssbuy-spreadsheet-guide',
  },
];

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="relative py-16 md:py-24 bg-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-xs md:text-sm text-foreground-300 font-label tracking-widest uppercase mb-4">
            Build Trust
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-3xl mx-auto">
            Verified Seller Links<br />
            Live QC Updates<br />
            <span className="italic font-medium text-primary-400">Community Tested</span>
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <button
            onClick={() => navigate('/article/cssbuy-spreadsheet-guide')}
            className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-line"></i>
          </button>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-background-200 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Visit Main Store
            <i className="ri-external-link-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featureCards.map((card) => (
            <button
              key={card.title}
              onClick={() => navigate(card.link)}
              className="group flex flex-col items-center gap-3 p-5 rounded-2xl cursor-pointer hover:scale-[1.03] transition-transform duration-200 bg-foreground-900"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${card.icon} text-2xl text-background-50`}></i>
              </div>
              <div className="text-center">
                <p className="text-sm font-semibold text-background-50 whitespace-nowrap">{card.title}</p>
                <p className="text-xs text-foreground-400 mt-1">{card.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}